<template>
  <el-form-item :class="{ 'is-required': required, 'is-mustbe': required }" :label="label" :prop="prop">
    <el-tooltip :content="currentValue" placement="top" :open-delay="300" v-if="tooltip">
      <el-input
        v-if="$attrs.type === 'number'"
        :class="{ [`is-${size}`]: true, mr5: $slots.default }"
        v-model.number="currentValue"
        v-bind="$attrs"
      >
        <template slot="append">
          <slot name="append"></slot>
        </template>
      </el-input>
      <el-input v-else :class="{ [`is-${size}`]: true, mr5: $slots.default }" v-model="currentValue" v-bind="$attrs">
        <template slot="append">
          <slot name="append"></slot>
        </template>
      </el-input>
    </el-tooltip>
    <template v-else>
      <el-input
        v-if="$attrs.type === 'number'"
        :class="{ [`is-${size}`]: true, mr5: $slots.default }"
        v-model.number="currentValue"
        v-bind="$attrs"
      >
        <template slot="append">
          <slot name="append"></slot>
        </template>
      </el-input>
      <el-input v-else :class="{ [`is-${size}`]: true, mr5: $slots.default }" v-model="currentValue" v-bind="$attrs">
        <template slot="append">
          <slot name="append"></slot>
        </template>
      </el-input>
    </template>
    <slot></slot>
  </el-form-item>
</template>

<script>
export default {
  name: 'NyFormItemInput',
  props: {
    value: {
      required: true
    },
    required: Boolean,
    size: {
      type: String,
      default: 'large'
    },
    label: String,
    prop: String,
    tooltip: Boolean
  },
  data () {
    return {
      currentValue: this.value
    }
  },
  watch: {
    value (newVal) {
      this.currentValue = newVal
    },
    currentValue (value) {
      this.$emit('input', value)
      this.$emit('change', value)
    }
  }
}
</script>
